import { Button } from '@planuze/ui';
import type { ReactNode } from 'react';

interface Props {
  readonly selectedLabel: string;
  readonly clearLabel: string;
  readonly busy: boolean;
  readonly onClear: () => void;
  readonly children: ReactNode;
}

/** Estrutura visual comum para lotes; a page continua dona da ação e da confirmação. */
export function BulkSelectionBar({ selectedLabel, clearLabel, busy, onClear, children }: Props) {
  return (
    <div
      role="toolbar"
      className="flex flex-wrap items-center gap-3 rounded-md border border-border bg-muted/30 px-4 py-2"
    >
      <span className="text-sm font-medium text-foreground">{selectedLabel}</span>
      {children}
      <Button size="sm" variant="ghost" disabled={busy} onClick={onClear}>
        {clearLabel}
      </Button>
    </div>
  );
}
